import React from 'react'

const Footerlanding = () => {
  return (
    <div>
      <footer className="bg-white text-black py-4 sm:py-6 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.2)]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row gap-4">
            {/* Logo and Description */}
            <div className="w-full md:w-2/5 mb-4 md:mb-0">
              <div className="mb-2">
                <img 
                  src="/assets/Transparent background.png"
                  alt="Ducktail Logo"
                  className="h-16 sm:h-20 filter brightness-0"
                />
              </div>
              <p className="text-sm sm:text-base max-w-md">
                Ducktail - The Construction Platform is your trusted construction
                partner connecting you with nearby verified and qualified builders
                in your region.
              </p>
            </div>

            {/* Middle Section - Links */}
            <div className="w-full md:w-1/3 mb-4 md:mb-0">
              <h4 className="text-sm sm:text-base font-bold mb-2">USEFUL LINKS</h4>
              <div className="flex">
                <div className="w-1/2">
                  <div className="text-sm sm:text-base mb-1"><a href="/" className="hover:underline text-black">➲ Home</a></div>
                  {/* <div className="text-sm sm:text-base mb-1"><a href="/" className="hover:underline text-black">➲ About us</a></div> */}
                  <div className="text-sm sm:text-base mb-1"><a className="hover:underline text-black">➲ Join us</a></div>
                  <div className="text-sm sm:text-base mb-1 pl-4">
                    <a href="/login?type=builder" className="hover:underline text-black">• Builders</a>
                  </div>
                  <div className="text-sm sm:text-base mb-1 pl-4">
                    <a href="/login?type=customer" className="hover:underline text-black">• Customers</a>
                  </div>
                  <div className="text-sm sm:text-base mb-1"><a href="/#services" className="hover:underline text-black">➲ Service</a></div>
                </div>
                <div className="w-1/2">
                  {/* <div className="text-sm sm:text-base mb-1"><a href="/" className="hover:underline text-black">➲ Career</a></div> */}
                  <div className="text-sm sm:text-base mb-1"><a href="/support" className="hover:underline text-black">➲ Support</a></div>
                  {/* <div className="text-sm sm:text-base mb-1"><a href="/" className="hover:underline text-black">➲ Blog</a></div> */}
                </div>
              </div>
            </div>

            {/* Right Section - Contact */}
            <div className="w-full md:w-1/4">
              <h4 className="text-sm sm:text-base font-bold mb-2">CONTACT US</h4>
              <div className="text-sm sm:text-base mb-1">📍 Tamil Nadu</div>
              <div className="text-sm sm:text-base mb-1">📧 connect@ducktail.in</div>
              <div className="text-sm sm:text-base mb-1">📞 +91 99427 28804</div>
            </div>
          </div>
          
          {/* Copyright Section */}
          <div className="mt-4 sm:mt-6 pt-2 sm:pt-3 border-t border-gray-200 text-xs sm:text-sm">
            <div className="flex flex-col md:flex-row justify-between">
              <div>Copyright © 2024 Ducktail, All rights reserved.</div>
              <div className="flex mt-2 md:mt-0 space-x-4 sm:space-x-6">
                <a href="/termscondition" className="text-black hover:underline">Terms and Condition</a>
                <a href="/privacypolicy" className="text-black hover:underline">Privacy Policy</a>
                <a href="/refundpolicy" className="text-black hover:underline"> Refund Policy</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footerlanding